module.exports = __webpack_public_path__ + "img/Barbell Right Salone.aea52fe6.png";